import { Injectable } from '@angular/core';
import { HcrService } from './hcr-service.service';
import { EasyNotificationService } from './easy-notification.service';
import { DateHelper } from '../shared/helpers/date-helper';

@Injectable({
  providedIn: 'root'
})
export class DebugLogService {
  
  constructor(
    private hcrService:HcrService,
    private notification:EasyNotificationService
  ) {
    notification.onNotify.subscribe(async x=>{
      await this.ClientLog(x.lv as any,x.s,x.m)
    })
    hcrService.onConnected.subscribe(async b=>{
      var msgs = this.stackedMsg;
      this.stackedMsg = [];
      for(let m of msgs){
        //延遲紀錄
        await this.ClientLog(m.logLevel,m.isSuccess,`[${DateHelper.formatDateTime(m.dt)}]${m.message}`);
      }
    })
  }
  
  stackedMsg:{logLevel:'Error'|'Warning'|'Info',isSuccess:boolean,message:string,dt:Date}[] = [];
  async ClientLog(logLevel:'Error'|'Warning'|'Info',isSuccess:boolean,message:string){
    try{
      if(!this.hcrService.ConnectStatus){
        this.stackedMsg.push({
          logLevel,isSuccess,message,dt:new Date()
        })
      }else{
        var ret = await this.hcrService.sendMsg(({ Call: 'WriteLog', Args: { 'Status': isSuccess, 'Level': logLevel,Message:message } }))
      }
      
    }catch(ex){
      //失敗就算了
    }
  }
  /** 用方法取得訊息 出錯算裡面的catch */
  async ClientLog2(logLevel:'Error'|'Warning'|'Info',isSuccess:boolean,message:()=>string){
    try{
      var msg = message();
      var ret = await this.hcrService.sendMsg(({ Call: 'WriteLog', Args: { 'Status': isSuccess, 'Level': logLevel,Message:msg } }))
    }catch(ex){
      //失敗就算了
    }
  }
}

